<template>
  <div>
    <component
      v-for="{name, args} in cpt_names"
      :is="name"
      :key="name"
      :args="args"
      ref="cpt"
    />
  </div>
</template>

<script>
import EventBus from '@/common/EventBus'
import importsComponentMixin from './imports'
export default {
  data() {
    return {
      cpt_names: [],
    }
  },
  mixins: [ importsComponentMixin ],
  mounted() {
    EventBus.$on('show-dynamic-dialog', this.initCpt)
    EventBus.$on('hide-dynamic-dialog', this.closeCpt)
    this.registerSocketEvent(1)
  },
  beforeDestroy() {
    EventBus.$off('show-dynamic-dialog', this.initCpt)
    EventBus.$off('hide-dynamic-dialog', this.closeCpt)
    this.registerSocketEvent(0)
  },
  methods: {
    initCpt (name = '', ...args) {
      if (!name) return
      if (typeof name !== 'string') {
        console.warn('name must be string')
        return
      }
      console.log('initCpt', name, args);
      if (!this.cpt_names.find(cpt => cpt.name === name)) {
        this.cpt_names.push({name, args})
      }
    },
    closeCpt (name) {
      if (!name) {
        throw new Error('错误的hide-dynamic-dialog事件或DynamicDialog组件未声明name属性')
      }
      console.log('closeCpt', name);
      const index = this.cpt_names.findIndex(cpt => cpt.name === name)
      if (index !== -1) {
        let cpt = this.$refs.cpt[index]
        cpt && (cpt.show = false)
        // 延时等待弹窗动画结束
        setTimeout(() => {
          // 重新获取index, 防止延时过程中组件数组变化
          const index = this.cpt_names.findIndex(cpt => cpt.name === name)
          if (index !== -1) {
            this.cpt_names.splice(index, 1)
          }
        }, 200)
      }
    },
    registerSocketEvent(bl) {
      const list = [
        ['SOCKET_USER_LEVEL_UP', (d) => {EventBus.$dynamic('UserLevelUpdate', d)}]
      ]
      list.forEach(([key, func]) => {
        if (bl) {
          EventBus.$on(key, func)
        } else {
          EventBus.$off(key, func)
        }
      })
    }
  }
}
</script>